/*
 * types/services/dr2am.tasks.preferences.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbPreference} from './PbPreference';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceGetPreferenceWithUserResponse model module.
 * @module model/ServiceGetPreferenceWithUserResponse
 * @version version not set
 */
export class ServiceGetPreferenceWithUserResponse {
  /**
   * Constructs a new <code>ServiceGetPreferenceWithUserResponse</code>.
   * @alias module:model/ServiceGetPreferenceWithUserResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceGetPreferenceWithUserResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceGetPreferenceWithUserResponse} obj Optional instance to populate.
   * @return {module:model/ServiceGetPreferenceWithUserResponse} The populated <code>ServiceGetPreferenceWithUserResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceGetPreferenceWithUserResponse();
      if (data.hasOwnProperty('preference'))
        obj.preference = ApiClient.convertToType(data['preference'], [PbPreference]);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {Array.<module:model/PbPreference>} preference
 */
ServiceGetPreferenceWithUserResponse.prototype.preference = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceGetPreferenceWithUserResponse.prototype.state = undefined;


